import { Flex } from 'front-commons/ds';
import styled, { keyframes } from 'styled-components';
import { UNDO_TIME } from 'containers/Drawers/PromotionSuggestion/helpers';

const progressAnimation = keyframes`
	from { width: 0px }
	to { width: 100% }
`
export const Container = styled(Flex)`
	[data-component-name="progress-bar"] {
		animation: ${progressAnimation} ${UNDO_TIME}ms forwards linear;
	}

	button * {
		cursor: inherit;
	}
`;
